import type { GuestsSelection } from "@b2bportal/lodging-api";

export interface CacheKey {
  lodgingId: string;
  fromDate: string;
  untilDate: string;
  guests: GuestsSelection;
  rooms: number;
}

export const cacheKey = ({
  lodgingId,
  fromDate,
  untilDate,
  guests,
  rooms,
}: CacheKey): string =>
  `${lodgingId}:${fromDate}:${untilDate}:${guests.adults}:${[...guests.children].sort().join(",")}:${guests.pets ?? 0}:${rooms}`;
